import React, { useCallback, useState } from "react";
import { useHttpGet } from "../../components/hooks/useHttp";
import styles from "./dashboard.module.scss";
import { Spin } from 'antd';
import * as utils from "../../utils/utils";
import { Modal, Button, Form } from "react-bootstrap";
import Footer from "../../components/footer/Footer";
import FavDashboard from "./FavDashboard";
import LoadJSON from "./LoadJSON";

const Dashboard = (props) => {

  const [loading] = useState(false)
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [acknowledgeData, setAckData] = useState(null);
  const [isAckUpdated, setAckFlagUpdate] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState(JSON.parse(sessionStorage.getItem("selectedRegion")));//EMEA Release-
  const [dataLoaded, setDataLoaded]= useState(false);
  const [isFavLoadng, setIsFavLoading]= useState(false);
  let bannerUrl = `filePath=kpi-configuration&fileName=banner-information.json`;
  let ackUrl = `filePath=dashboard&fileName=ack-information.json`;


  const handleRegionChange = (reg) => {/*EMEA Release- - Added handler for region selection- radiobutton  */
    setSelectedRegion(reg);
    sessionStorage.setItem("selectedRegion", JSON.stringify(reg));
    props.setRegion(reg);
    //parseData(dashboardData, reg); //NEED TO LOOK WHILE REFACTORING
   //getFavorites();//NEED TO LOOK WHILE REFACTORING
  }

  const regionSelection = (region) => {/*EMEA Release- - Added handler for region selection- radiobutton  */
    if (JSON.parse(sessionStorage.getItem("selectedRegion")).toLowerCase() === region.toLowerCase())
      return true;
    else {
      return false;
    }
  }



  const processBannerData = useCallback((bannerData) => {
    console.log("processBannerData--bannerData", bannerData);
    bannerData.sort(utils.sorting('page', 'string', true));
    props.setBanner(bannerData);
  },[props]);

   const [isBannerLoading] = useHttpGet(bannerUrl,processBannerData);
  
 // const [isBannerLoading, fetchedBannerData] = useHttpGet(bannerUrl,processBannerData);
 // console.log("fetchedBannerData", fetchedBannerData);

  const processAckData = useCallback((ackData) => {
    console.log("processAckData--ackData", ackData);
    setAckData(ackData);
  },[]);
  
  const [isAckLoading] = useHttpGet(ackUrl, processAckData);
  // const [isAckLoading, fetchedAckData] = useHttpGet(ackUrl, processAckData);
  // console.log("fetchedAckData", fetchedAckData);
  
  const checkIsAckAcknowledged = () => {
    let flag = true;
    if (acknowledgeData && acknowledgeData.length > 0) {
      acknowledgeData.forEach(element => {
        if (element.id === props.userInfo) {
          flag = false;
        }
      });
    }
    return flag;
  }
  const handleAckSubmit = () => {
    setAckFlagUpdate(true);
    const data = {
      id: props.userInfo,
      isAcknowledged: true
    }
    utils.getData('editackinformation', 'POST', data)
      .then(resp => {
        setAckFlagUpdate(false);
        handleClose();
      })
      .catch(error => {
        console.log(error);
        setAckFlagUpdate(false);
      })
  }

  const isDataLoaded = (data)=>{
    setDataLoaded(data);
  }

  const isFavLoading = (data)=>{
    setIsFavLoading(data);
  }
 
  return (
    <Spin spinning={ loading || isBannerLoading || isAckLoading || isFavLoadng} >
      {
        props && props.userInfo && checkIsAckAcknowledged() ? (
          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <span className={styles.ackTitle}>
                  Acknowledgement Confirmation
                </span>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              VOICE Platform is company confidential and for internal use only. Any information from VOICE should never be shared with customers or other external stakeholders.
            </Modal.Body>
            <Modal.Footer>
              <span className={styles.spinAlign}>
                <Spin spinning={isAckUpdated}></Spin>
              </span>
              <Button variant="primary" className={styles.customBtn} onClick={() => handleAckSubmit()}>I acknowledge</Button>
            </Modal.Footer>
          </Modal>
        ) : null
      }
      <div className={styles.container}>
        {
          dataLoaded && <div className={styles.radioWrapper}>
            <span className={styles.radioLabel}>Select Region </span>
            <Form className={styles.radioForm}>
              <div key={`inline-radio`} className="mb-3">
                <Form.Check
                  inline
                  defaultChecked= {regionSelection("NA")}
                  className={styles.formRadioInline}
                  label="NA"
                  name="region"
                  type="radio"
                  onClick={() => handleRegionChange("NA")}
                  id={`inline-radio-1`} />
                <Form.Check
                  inline
                  defaultChecked={regionSelection("EMEA")}
                  className={styles.formRadioInline}
                  label="EMEA"
                  name="region"
                  type="radio"
                  onClick={() => handleRegionChange("EMEA")}
                  id={`inline-radio-2`} />
              </div>
            </Form>
          </div>
        }
        <LoadJSON region={selectedRegion} isDataLoaded={isDataLoaded}  {...props}/>  
        {<FavDashboard  isFavLoading={isFavLoading} selectedRegion={selectedRegion} {...props}/>}
        {dataLoaded && <Footer {...props}/> }
      </div> 
      
    </Spin >)
};

export default Dashboard;